import React, { ReactNode } from "react";

interface ButtonProps {
  /**@deprecated use children instead */
  label?: ReactNode | string;
  children?: ReactNode | string;
  icon?: ReactNode;
  onClick: (
    e: React.MouseEvent<HTMLButtonElement> | React.FormEvent<HTMLFormElement>
  ) => void;
  type?: "primary" | "secondary";
  disabled?: boolean;
  className?: string;
  title?: string;
  onMouseEnter?: (e: React.MouseEvent<HTMLButtonElement>) => void;
}

const Button: React.FC<ButtonProps> = ({
  label,
  children,
  onClick,
  type = "primary",
  disabled = false,
  className = "",
  title = "",
  onMouseEnter,
  icon,
}) => {
  const baseStyle = "btn-base";
  const primaryStyle = "btn-primary";
  const secondaryStyle = "btn-secondary";
  const disabledStyle = "btn-disabled";

  const style = `${baseStyle} ${
    type === "primary" ? primaryStyle : secondaryStyle
  } ${disabled ? disabledStyle : ""} ${className}`;

  return (
    <button
      className={style}
      onClick={disabled ? (e) => e.preventDefault() : onClick} // Manually handle disabled click
      onMouseEnter={onMouseEnter} // This will still fire
      title={title}
    >
      {icon && <span className="mr-2 inline-flex">{icon}</span>}
      {children || label}
    </button>
  );
};

export default Button;
